

import React, { forwardRef } from 'react';

import { ApolloConsumer } from 'react-apollo';
import { UploaderConsumer } from '../../Uploader';
import RequestProvider from '../../RequestProvider';
import PureCommentsComponent from '../components/CommentsProvider';
import {
  getCommentsApi,
  updateCommentApi,
  createCommentApi,
  deleteCommentApi,
  updateViewersApi } from
'../api';
import getOrganisation from '../api/getOrganisation';



























function CommentProvider(
{
  resourceId,
  versionIds,
  resourceOrganisationId,
  children,
  modalTarget,
  filterByMetadataFlag,
  isReadOnly,
  canResolveComment,
  onCommentAssetsChange,
  relatedToId,
  relatedToType,
  resourceOwnerUserId,
  sceneId,
  shotId,
  disableNotifications,
  isInternalMode,
  commentOrigin,
  notCommentOrigin,
  currentActivePage,
  pagesList,
  allowedVisibilityOptions,
  allowedWriteVisibilityOptions,
  shouldNotFetchOnMount
},
ref)
{
  return (
    <ApolloConsumer>
      {(apiClient) =>
      <UploaderConsumer>
          {({ fetchAssets, assetsMap }) =>
        <RequestProvider
          requests={{
            getCommentsRequest: getCommentsApi(),
            updateCommentRequest: updateCommentApi(),
            createCommentRequest: createCommentApi(),
            deleteCommentRequest: deleteCommentApi(),
            updateViewersRequest: updateViewersApi(),
            getOrganisation: getOrganisation(resourceOrganisationId)
          }}>

              {(requests) =>
          <PureCommentsComponent
            resourceId={resourceId}
            versionIds={versionIds}
            resourceOrganisationId={resourceOrganisationId}
            fetchAssets={fetchAssets}
            modalTarget={modalTarget}
            filterByMetadataFlag={filterByMetadataFlag}
            isReadOnly={isReadOnly}
            canResolveComment={canResolveComment}
            onCommentAssetsChange={onCommentAssetsChange}
            relatedToId={relatedToId}
            relatedToType={relatedToType}
            ref={ref}
            apiClient={apiClient}
            resourceOwnerUserId={resourceOwnerUserId}
            assetsMap={assetsMap}
            sceneId={sceneId}
            shotId={shotId}
            disableNotifications={disableNotifications}
            isInternalMode={isInternalMode}
            commentOrigin={commentOrigin}
            notCommentOrigin={notCommentOrigin}
            currentActivePage={currentActivePage}
            pagesList={pagesList}
            allowedVisibilityOptions={allowedVisibilityOptions}
            allowedWriteVisibilityOptions={allowedWriteVisibilityOptions}
            shouldNotFetchOnMount={shouldNotFetchOnMount}
            {...requests}>

                  {children}
                </PureCommentsComponent>}

            </RequestProvider>}

        </UploaderConsumer>}

    </ApolloConsumer>);

}

export default forwardRef(CommentProvider);